module.exports = __webpack_public_path__ + "img/9_4.510586b7.png";